(ns frontend.view.onboarding.terms-acceptance.events
  (:require
   [frontend.view.onboarding.terms-acceptance.db :as db]
   [frontend.actions.account :as server-account]
   [frontend.analytics :as analytics]
   [frontend.logging :as logging]))

(def hardcoded-new-terms-in-epoch 1526939281000)

(defn toggle-accept-terms
  [_]
  (swap! db/state assoc :accepted? (not (:accepted? @db/state))))

(defn submit!
  []
  (let [on-ok! (fn []
                 (analytics/event "Terms-accepted")
                 (logging/info "Terms Accepted"))           ;; we rely on account subscription to change the state for UI to change
        on-error! logging/error]
    (server-account/*->accept-terms on-ok! on-error!)))

(defn has-to-accept-terms?
  []
  (let [account-role @db/role
        last-accepted (or (get @db/account-terms-accepted (:db/id @db/tenant)) 
                          0)
        needs-accepting? (and (not (:tenant/has-custom-tos @db/tenant)) ;; no custom terms
                              (some #{account-role} [:role/user :role/admin]) ; logged in as either user or admin
                              (< last-accepted hardcoded-new-terms-in-epoch))] ;; terms haven't been accepted since new terms)
    needs-accepting?))
